/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ScenarioRecordingState {
    Prepared = 0,
    Recording = 1,
    Stopped = 2,
    Aborted = 3,
}
